import axios from "axios";

const headers = {
  Accept: "application/json",
};

const api = axios.create({
  baseURL: "https://topus-desafio-api.herokuapp.com/",
  // baseURL: "http://localhost:3333/",
});

const apiPHP = axios.create({
  baseURL: "https://fococomunicacao.com.br/topus-video-react-api",
  // baseURL: "http://localhost/",
})

export { apiPHP };
export default api;
